/**
 * MyClips V3 — Trending Creators Client (Sprint 26 A).
 *
 * `trendingCreators/{uid}` koleksiyonunu okur. Cloud Function
 * `detectTrendingCreatorsV3Scheduled` daily 04:00 İstanbul'da bu
 * koleksiyonu doldurur (Sprint 21 followerSnapshots delta'sı). Client
 * tarafında salt okuma — yazma yok.
 *
 * `fetchTrendingCreators({ limit })`
 *   → trending=true filtreli, trendScore desc sıralı top-N creator döner.
 *
 * Şekil:
 *   {
 *     uid, displayName, photoURL, username,
 *     followersCount, followerGain24h, trendScore, updatedAt
 *   }
 */

import {
  collection,
  getDocs,
  limit as fsLimit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

export const TRENDING_CREATORS_COL = "trendingCreators";

/** `fetchTrendingCreators` satırı — map gövdesinden türetildi. */
export interface TrendingCreator {
  uid: string;
  displayName: string;
  photoURL: string | null;
  username: string | null;
  followersCount: number;
  followerGain24h: number;
  trendScore: number;
  /** `updatedAt` Timestamp → ms; yoksa null. */
  updatedAt: number | null;
}

export async function fetchTrendingCreators({
  limit = 50,
}: { limit?: number } = {}): Promise<TrendingCreator[]> {
  const q = query(
    collection(db, TRENDING_CREATORS_COL),
    where("trending", "==", true),
    orderBy("trendScore", "desc"),
    fsLimit(Math.max(1, Math.min(100, limit))),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data() || {};
    return {
      uid: data.uid || d.id,
      displayName: data.displayName || "Kullanıcı",
      photoURL: data.photoURL || null,
      username: data.username || null,
      followersCount: Number(data.followersCount) || 0,
      followerGain24h: Number(data.followerGain24h) || 0,
      trendScore: Number(data.trendScore) || 0,
      updatedAt: data.updatedAt?.toMillis?.() || null,
    };
  });
}

export default { fetchTrendingCreators, TRENDING_CREATORS_COL };
